import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=5e00c4bd&scoped=true"
import script from "./product.js?vue&type=script&lang=js&external"
export * from "./product.js?vue&type=script&lang=js&external"
import style0 from "./product.scss?vue&type=style&index=0&id=5e00c4bd&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e00c4bd",
  null
  
)

export default component.exports